import "./slider.component.scss";

export default {
  template: require('./slider.component.html'),
  bindings: {
    options: "<?vuiOptions",
    model: "=ngModel",
    onChange: "<vuiChange",
    disabled: "@disabled"
  },
  controller: function ($element) {

    'ngInject';

    const self = this;

    self.$onInit = () => {
      if (!self.options) {
        self.options = {};
      }
      if (!self.options.max) {
        self.options.max = 10;
      }
      if (!self.options.min) {
        self.options.min = 0;
      }
      if (!self.options.step) {
        self.options.step = 1;
      }
      if (!self.model && self.model !== self.options.min) {
        self.model = (self.options.min + self.options.max) / 2;
      }

      self.options.totalWidth = (self.options.max - self.options.min) / self.options.step;
      const model = (self.size - self.options.min) / self.options.step;
      self.size = (model / self.options.totalWidth) * 100;

      recalculate();

      $element.children().children().children()[1].value = self.model;
    }

    const recalculate = () => {
      self.model = Math.round(self.model / self.options.step) * self.options.step;
      const model = (self.model - self.options.min) / self.options.step;
      self.size = (model / self.options.totalWidth) * 100;
    }

    self.onSlide = (e) => {
      if (self.disabled) {
        return;
      }

      recalculate();
    }

    self.onChanged = (e) => {
      if (self.disabled) {
        return;
      }

      recalculate();
      if (self.onChange) {
        self.onChange();
      }
    }

    self.labelFormat = (value) => {
      if (self.options.translate) {
        return self.options.translate(value);
      }

      return value;
    }

  }
};
